/**
* @name: index
* @author: weiyong
* @date: 2022-10-26 22:14
* @description：index
* @update: 2022-10-26 22:14
*/
<template>
  <!-- 只读模式：使用 XmInputCell 组件显示 -->
  <XmInputCell v-if="isReadOnly" :record="record" :column="column" :cellContent="record[column.dataIndex]" />
  <!-- 编辑模式：输入框 -->
<div v-else-if="hiddenFlag===true?false:true" class="InputEditor xmInput w100b flex-div">
    <a-input
      :size="column.ctlSize"
      :disabled="readOnlyFlag?true:(editorFlag?false:(disabled||vuex['disabled']||disabledFun))"
      :class="hasError?'item-has-error':''"
      v-model:value="record[column.dataIndex]"
      @change="changeInput"
      @blur="blurInput"
      :errorMsg="errorMsg"
      :showCount="column.showCount===true?true:false"
      :maxlength="column.maxlength?column.maxlength:null"
      :hasError="hasError"
      :placeholder="disabled?'':getDefPlaceholder"
      :name="'___'+column.dataIndex"
      @pressEnter="pressEnter"
    />
    <div class="hasErrorDiv" v-if="hasError&&errorMsg">
      <a-tooltip>
        <template #title>{{errorMsg}}</template>
        &nbsp;<span class="remix-icon ri-error-warning-line"></span>
      </a-tooltip>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "InputEditor",
});
</script>

<script lang="ts" setup>
import {Tooltip as ATooltip,Input as AInput} from 'ant-design-vue';
import XmInputCell from "@/main-page/gridCellCtlShow/cellCtls/xmInputCell/index.vue";
import {useCellEditorComHooks} from "@/main-page/gridCellEditor/editorCtls/hooks/useCellEditorComHooks";
import {useFieldDefHooks} from "@/main-page/gridCellEditor/editorCtls/hooks/useFieldDefHooks";
import {useSimpleFlowAclHooks} from "@/main-page/gridCellEditor/hooks/useSimpleFlowAclHooks";
import {useVuexState} from "@/main-page/ctls/hooks/useVuexState";
import {CtlComEnum} from "@/main-page/enums/ctlComEnum";
import {computed, unref} from "vue";

// 显式定义组件名称，避免类型错误
defineOptions({
  name: 'InputEditor',
  components: {
    XmInputCell
  }
});

interface IProps {
  size: string,
  validate: string,
  record: any,
  column: any,
  disabled: boolean,
  cellContent: any,
  index: number,
}

const props = withDefaults(defineProps<IProps>(), {
  size: 'default',
  record: {},
  column: {},
  validate: '',
  disabled: false,
  cellContent: null,
  index: -1,
})
const {record, column, validate, index} = toRefs(props);

const {vuex} = useVuexState({sectionConfig: column,record,  vuexProps: [CtlComEnum.DEFAULT_DIS]});
const emits = defineEmits(['changeCellVal', 'initValidateFlag']);
const {
  getDefPlaceholder,
  hasError,
  errorMsg,
  changeInput,
  blurInput
}=useCellEditorComHooks({formDomainObj:inject('formDomainObj'),emits, validate,gridKey:inject('grid-ctl-key'),  column, record, index});
/**
 * 设置默认值
 */
const{model}=useFieldDefHooks({column,pItemType:inject('pItemType'),componentKey:'InputEditor', record});
const pressEnter = (id)=>{
  if(window.pressEnterSubGrid){
    window.pressEnterSubGrid()
  }
}

const flowContainer = inject('flowContainer');
const {
  disabledFun,
  readOnlyFlag,
  hiddenFlag,
  editorFlag
}=useSimpleFlowAclHooks({column,flowContainer,record});

// 列配置 readOnly 才换只读文本；流程 readOnlyFlag 只禁用编辑器，保留边框
const isReadOnly = computed(() => {
  return unref(column).readOnly === true;
});


</script>

<style type="text/css" lang="less">
.editor-cell{
  .InputEditor.xmInput{
    .ant-input-sm{
      height:22px;
    }
  }
}
.xmForm.readOnlyText .xmInput .ant-input[disabled] {
  background-color: transparent;
  color: rgba(0, 0, 0, 0.85);
}
</style>

